import {Route, Routes, Navigate} from "react-router-dom";
import {SharedLayout} from "./pages/SharedLayout/SharedLayout";
import {Home} from "./pages/Home/Home";
import {Products} from "./pages/Products/Products";
import {Subscribe} from "./pages/Subscribe/Subscribe";
import {AboutUs} from "./pages/AboutUs/AboutUs";
import {Resources} from "./pages/Resources/Resources";
import {FAQ} from "./pages/FAQ/FAQ";

function App() {
  return (
          <Routes>
              <Route path="/" element={<SharedLayout />}>
                  <Route index element={<Home />} />
                  <Route path="products" element={<Products />} />
                  <Route path="subscribe" element={<Subscribe />} />
                  <Route path="about-us" element={<AboutUs />} />
                  <Route path="resources" element={<Resources />} />
                  <Route path="faq" element={<FAQ />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
  );
}

export default App;
